export default __webpack_public_path__ + "static/media/Coding-project.0c00aaef.svg";